import { AddGrowingSeasonArguments } from "@/features/growing-season/data/datasources/growing-season-datasources";
import { Season } from "@/features/growing-season/domain/growing-season.interface";
import { City, Farm, Province } from "@/features/farm/domain/farm.interface";
import {
  addGrowingSeason,
  deleteFields,
  getFarmersFields,
  getFarms,
  getStaticCities,
  getStaticIrrigationSources,
  getStaticOwnershipType,
  getStaticProvinces,
  updateField,
} from "@/features/farm/data/datasources/farm-datasources";

export interface FarmRepository {
  _getFarms: () => Promise<Farm[] | undefined>;
  _getFarmersFields: () => Promise<any | undefined>;
  _getStaticIrrigationSources: () => Promise<any | undefined>;
  _getStaticOwnershipType: () => Promise<any | undefined>;
  _getStaticCities: () => Promise<City[] | undefined>;
  _getStaticProvinces: () => Promise<Province[] | undefined>;
  _addGrowingSeason: ({
    season,
    farmId,
  }: AddGrowingSeasonArguments) => Promise<Season | undefined>;
  _updateField: ({ data }: any) => Promise<Season | undefined>;
  _deleteFields: (farmId: string) => Promise<string | undefined>;
}

export class FarmRepositoryImpl implements FarmRepository {
  _getFarms = async (): Promise<Farm[] | undefined> => {
    return await getFarms();
  };

  _getFarmersFields = async (): Promise<any | undefined> => {
    return await getFarmersFields();
  };

  _getStaticIrrigationSources = async (): Promise<any | undefined> => {
    return await getStaticIrrigationSources();
  };

  _getStaticOwnershipType = async (): Promise<any | undefined> => {
    return await getStaticOwnershipType();
  };
  
  _getStaticCities = async (): Promise<City[] | undefined> => {
    return await getStaticCities();
  };

  _getStaticProvinces = async (): Promise<Province[] | undefined> => {
    return await getStaticProvinces();
  };

  _addGrowingSeason = async ({
    season,
    farmId,
  }: AddGrowingSeasonArguments): Promise<Season | undefined> => {
    return await addGrowingSeason({ season, farmId });
  };
  _updateField = async ({ data }: any): Promise<Season | undefined> => {
    return await updateField({ data });
  };
  _deleteFields = async (farmId: string): Promise<string | undefined> => {
    return await deleteFields(farmId);
  };
}
